import React from 'react';
import classNames from 'classnames';
import { FieldArray } from 'react-final-form-arrays';
import { Field } from 'react-final-form';
import InputField from 'components/InputField';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import XIcon from 'icons/X.icon';
import PluscircleIcon from 'icons/Pluscircle.icon';
import TextAreaField from 'components/TextAreaField';
import EmailField from 'components/EmailField';

import './RecipientDetails.styles.scss';
import './RecipientDetails.styles.responsive.scss';

type RecipientDetailsProps = {
  className?: string;
  maxFields?: number;
};

const RecipientDetails: React.FC<RecipientDetailsProps> = (props) => {
  const { className, maxFields = 4 } = props;
  const { t } = useTranslation();
  const classes = classNames('recipient-details', className);

  return (
    <div className={classes}>
      <FieldArray name="recipientDetails">
        {({ fields }) => (
          <>
            {fields.map((name, index) => (
              <div key={name} className="companies__row">
                <Field
                  name={`${name}.firstName`}
                  component={InputField}
                  label={t('firstName')}
                />
                <EmailField name={`${name}.email`} />
                <Field
                  name={`${name}.customNote`}
                  component={TextAreaField}
                  label={t('addACustomNote')}
                />
                {index > 0 && (
                  <Button
                    onClick={() => fields.remove(index)}
                    variant="icon"
                    icon={XIcon}
                    className="remove"
                  />
                )}
              </div>
            ))}

            {fields.length < maxFields && (
              <Button
                variant="link"
                onClick={() => {
                  fields.push(undefined);
                }}
              >
                <PluscircleIcon />
                {t('addAnotherRecipient')}
              </Button>
            )}
          </>
        )}
      </FieldArray>
    </div>
  );
};

export default RecipientDetails;
